import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAddOpportunity } from '../models/requestModel'
import { CommonPostResponse } from '../../../components/models/models'

export class PostAddOpportunityApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/opportunitMarket/post',
      requesterInfo,
    })
  }

  public async postOpportunity(request: IAddOpportunity): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
